import { Avatar, Skeleton, UserOutlined } from "@mimber/ui-web"
import { useProfile } from "@mimber/client/mimber-organization"
import type { ProfileAvatarProps } from "./ProfileAvatar.types"

export const ProfileAvatar: React.FunctionComponent<ProfileAvatarProps> = ({
  showLoading = true,
  size = "default",
  ...rest
}) => {
  const { data, isLoading } = useProfile()

  if (isLoading && showLoading) {
    return (
      <Skeleton.Avatar
        active
        size={typeof size === "object" ? "default" : size}
      />
    )
  }

  const profile = data?.data
  const avatarUrl = profile?.avatarUrl || undefined

  return (
    <Avatar
      src={avatarUrl}
      icon={!avatarUrl ? <UserOutlined /> : undefined}
      size={size}
      {...rest}
    />
  )
}
